export default defineNuxtRouteMiddleware(() => {
  const appStore = useAppStore()
  if (appStore.getToken === '') {
    return navigateTo('/login')
  }
})
